import { ReactNode } from 'react'
import { RecipientDetails } from '@/features/user/referrals/slice'
import { PlaceholderParagraph } from '@/components/PlaceholderParagraph'
import { TypographyStyles } from '@/styles'
import { Text } from '@/ui'

const MessageContent = ({
  header,
  body,
}: {
  header: string
  body: string | ReactNode
}) => (
  <>
    <Text variant={TypographyStyles.H1} className="w-1/2">
      {header}
    </Text>
    <Text className="w-1/2">{body}</Text>
  </>
)

export const ReferralWelcomeMessage = ({
  recipient,
  recipientLoading,
  freeTrialEnabled,
}: {
  recipient?: RecipientDetails
  recipientLoading: boolean
  freeTrialEnabled: boolean
}) => (
  <>
    {recipientLoading && (
      <PlaceholderParagraph className="w-full block w-[400px]" />
    )}

    {recipient?.responseCode === 'details_not_found' && (
      <MessageContent
        header={'This invitation cannot be found'}
        body={'Please double-check the link you clicked and try again.'}
      />
    )}

    {recipient?.responseCode === 'already_accepted_invitation' && (
      <MessageContent
        header={'This invitation has already been redeemed'}
        body={`${recipient.firstName}, it looks like you've already signed up using this invitation.`}
      />
    )}

    {recipient?.responseCode === 'success' && (
      <MessageContent
        header={`Welcome to Heard, ${recipient.firstName}!`}
        body={
          freeTrialEnabled
            ? `We're so happy that ${recipient.senderFirstName} referred you to
        us! Let's get you started with your free 30 day trial.`
            : `We're so happy that ${recipient.senderFirstName} referred you to us! `
        }
      />
    )}
  </>
)
